import React from 'react';
import { Card, Row, Col } from '@/components/ui';
import { Project } from '../../../types/Project';
import { formatDollars } from '../../../utils/formatDollars';

interface ProjectQuantifiedRevenueProps {
  project: Project;
}

/**
 * Revenue display for Quantified projects: Planned Revenue (total planned task value) and
 * Actual Revenue (total value of started/completed tasks). Derived from task values on the
 * server (see calculateProjectAggregatedTotals), not from costs × markup.
 */
const ProjectQuantifiedRevenue: React.FC<ProjectQuantifiedRevenueProps> = ({ project }) => {
  const quantifiedRevenue = project.aggregatedTotals?.quantifiedRevenue ?? { planned: 0, actual: 0 };

  return (
    <Row>
      {/* Planned Revenue Box */}
      <Col md={6}>
        <Card className="tw-h-full">
          <Card.Body className="tw-p-2">
            <h6 className="tw-mb-1 tw-text-content-muted">Planned Revenue</h6>
            <p className="tw-mb-0 tw-text-success tw-font-semibold">
              {formatDollars(quantifiedRevenue.planned)}
            </p>
          </Card.Body>
        </Card>
      </Col>

      {/* Actual Revenue Box */}
      <Col md={6}>
        <Card className="tw-h-full">
          <Card.Body className="tw-p-2">
            <h6 className="tw-mb-1 tw-text-content-muted">Actual Revenue</h6>
            <p className="tw-mb-0 tw-text-success tw-font-semibold">
              {formatDollars(quantifiedRevenue.actual)}
            </p>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default ProjectQuantifiedRevenue;
